import { createAction } from 'redux-actions';

export const setKitchenAvgSizeAction = createAction('SET_KITCHEN_AVERAGE_SIZE');
export const resetKitchenAvgSizeAction = createAction('RESET_KITCHEN_AVERAGE_SIZE');
